export default __webpack_public_path__ + "static/media/sand5.98c9f772.png";